var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroFiltering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 248,
    viewBox: "0 0 40 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117.628 -217.217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.82 357.925h3.918c8.882 0 16.386 7.321 16.386 15.985v50.715a17.251 17.251 0 0017.228 17.233h.8a.623.623 0 100-1.246h-.8a16 16 0 01-15.985-15.985v-50.716c0-9.341-8.075-17.232-17.632-17.232h-3.918a3.38 3.38 0 010 1.246zM124.82 341.693h38.332a.623.623 0 100-1.246H124.82a3.38 3.38 0 010 1.246zM163.821 241.168a.626.626 0 00-.64-.628c-9.206.338-17.308 7.933-17.308 17.22v50.715c0 9.113-6.509 15.985-15.139 15.985h-5.914a3.379 3.379 0 010 1.246h5.914c9.341 0 16.385-7.408 16.385-17.232v-50.713c0-8.611 7.56-15.653 16.094-15.974a.623.623 0 00.608-.619z",
    fill: "#C1C1C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.82 324.461a3.38 3.38 0 10.058.623 3.627 3.627 0 00-.058-.623zm-3.567-1.755a2.378 2.378 0 11-2.378 2.378 2.381 2.381 0 012.377-2.378zM124.82 340.45a3.38 3.38 0 10.058.623 3.627 3.627 0 00-.058-.623zm-3.567-1.755a2.378 2.378 0 11-2.378 2.378 2.381 2.381 0 012.377-2.378zM124.82 356.886a3.38 3.38 0 10.058.623 3.627 3.627 0 00-.058-.623zm-3.567-1.755a2.378 2.378 0 11-2.378 2.378 2.381 2.381 0 012.377-2.378z",
    fill: "#C1C1C0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroFiltering);
export default __webpack_public_path__ + "static/media/intro__filtering.78464eb2e77d2f0c9031404e3a1c06c6.svg";
export { ForwardRef as ReactComponent };